/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonOpenRequest
 */
export interface UpgatesAddonOpenRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpenRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpenRequest
     */
    currentAdminLanguage: string;
    /**
     * 
     * @type {number}
     * @memberof UpgatesAddonOpenRequest
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpenRequest
     */
    time: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpenRequest
     */
    signatureV2: string;
}

/**
 * Check if a given object implements the UpgatesAddonOpenRequest interface.
 */
export function instanceOfUpgatesAddonOpenRequest(value: object): value is UpgatesAddonOpenRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('currentAdminLanguage' in value) || value['currentAdminLanguage'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('signatureV2' in value) || value['signatureV2'] === undefined) return false;
    return true;
}

export function UpgatesAddonOpenRequestFromJSON(json: any): UpgatesAddonOpenRequest {
    return UpgatesAddonOpenRequestFromJSONTyped(json, false);
}

export function UpgatesAddonOpenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonOpenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'currentAdminLanguage': json['current_admin_language'],
        'version': json['version'],
        'time': json['time'],
        'signatureV2': json['signature_v2'],
    };
}

export function UpgatesAddonOpenRequestToJSON(json: any): UpgatesAddonOpenRequest {
    return UpgatesAddonOpenRequestToJSONTyped(json, false);
}

export function UpgatesAddonOpenRequestToJSONTyped(value?: UpgatesAddonOpenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'current_admin_language': value['currentAdminLanguage'],
        'version': value['version'],
        'time': value['time'],
        'signature_v2': value['signatureV2'],
    };
}

